import React, { useState, useEffect } from 'react';
import { postAPI } from '../../../app/api';
import Swal from 'sweetalert2';

const CreateGroupemail = () => {
    const [groupName, setGroupName] = useState('');
    const [description, setDescription] = useState('');
    const [allMembers, setAllMembers] = useState([]);
    const [selectedMembers, setSelectedMembers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchAllMembers();
    }, []);

    const fetchAllMembers = async () => {
        try {
            setLoading(true);
            const response = await postAPI('communication-group/getAllMembers', {});
            if (response?.status === 1) {
                setAllMembers(response?.data || []);
            }
        } catch (error) {
            console.error('Error fetching members:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleMemberToggle = (member) => {
        const isSelected = selectedMembers.some(m => m.user_code === member.user_code);
        if (isSelected) {
            setSelectedMembers(selectedMembers.filter(m => m.user_code !== member.user_code));
        } else {
            setSelectedMembers([...selectedMembers, member]);
        }
    };

    const handleRemoveMember = (userCode) => {
        setSelectedMembers(selectedMembers.filter(m => m.user_code !== userCode));
    };

    const handleCreateGroup = async () => {
        if (!groupName.trim()) {
            Swal.fire('Validation', 'Please enter a group name', 'warning');
            return;
        }

        if (selectedMembers.length === 0) {
            Swal.fire('Validation', 'Please select at least one member', 'warning');
            return;
        }

        try {
            const response = await postAPI('communication-group/create', {
                group_name: groupName,
                description: description,
                members: selectedMembers
            });

            if (response?.status === 1) {
                Swal.fire('Success', 'Group created successfully', 'success');
                setGroupName('');
                setDescription('');
                setSelectedMembers([]);
            } else {
                Swal.fire('Error', response?.msg || 'Failed to create group', 'error');
            }
        } catch (error) {
            console.error('Error creating group:', error);
            Swal.fire('Error', 'Failed to create group', 'error');
        }
    };

    const filteredMembers = allMembers.filter(member => {
        const searchLower = searchTerm.toLowerCase();
        return (
            member.first_name?.toLowerCase().includes(searchLower) ||
            member.last_name?.toLowerCase().includes(searchLower) ||
            member.email_id?.toLowerCase().includes(searchLower) ||
            member.mobile_number?.includes(searchTerm)
        );
    });

    return (
        <div>
            <div className='card'>
                <div className='card-body'>
                    <div className='row mb-3'>
                        <div className='col-md-8'>
                            <div className='form-group mb-3'>
                                <label>Group Name *</label>
                                <input 
                                    type='text' 
                                    placeholder='Enter your group name' 
                                    className='form-control'
                                    value={groupName}
                                    onChange={(e) => setGroupName(e.target.value)}
                                />
                            </div>
                            <div className='form-group'>
                                <label>Description</label>
                                <textarea
                                    placeholder='Enter group description'
                                    className='form-control'
                                    rows="2"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                ></textarea>
                            </div>
                        </div>
                        <div className='col-md-4 d-flex align-items-end'>
                            <button 
                                className='btn btn-primary w-100'
                                onClick={handleCreateGroup}
                            >
                                Create Group
                            </button>
                        </div>
                    </div>

                    <div className='selected-member d-flex align-items-center mt-3'>
                        <h4 className='mb-0 me-3'>Selected Members: {selectedMembers.length}</h4>
                        <ul className='d-flex gap-2 align-items-center mb-0 flex-wrap'>
                            {selectedMembers.map((member) => (
                                <li key={member.user_code}>
                                    <span className="badge rounded-pill bg-secondary">
                                        {member.first_name} {member.last_name}
                                        <button 
                                            className='btn-close btn-close-white ms-2'
                                            style={{ fontSize: '10px' }}
                                            onClick={() => handleRemoveMember(member.user_code)}
                                        ></button>
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    
                    <hr></hr>
                    
                    <div className='d-flex justify-content-between align-items-center mb-3'>
                        <h3 className='mb-0'>All Members ({filteredMembers.length})</h3>
                        <div className='form-group mb-0' style={{ width: '300px' }}>
                            <input 
                                placeholder='Search member' 
                                type='text' 
                                className='form-control'
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                    
                    <div className='member-list'>
                        {loading ? (
                            <div className="text-center py-5">
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <table className='table table-striped table-hover cus-table'>
                                <thead className='table-dark'>
                                    <tr>
                                        <th>Select</th>
                                        <th>Name</th>
                                        <th>Email ID</th>
                                        <th>Phone</th>
                                        <th>Passing Year</th>
                                        <th>Discipline</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredMembers.length > 0 ? (
                                        filteredMembers.map((member, index) => {
                                            const isSelected = selectedMembers.some(m => m.user_code === member.user_code);
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        <input 
                                                            type='checkbox' 
                                                            className='form-check-input' 
                                                            checked={isSelected}
                                                            onChange={() => handleMemberToggle(member)}
                                                        />
                                                    </td>
                                                    <td>{member.first_name} {member.middle_name} {member.last_name}</td>
                                                    <td>{member.email_id || '-'}</td>
                                                    <td>{member.mobile_number || '-'}</td>
                                                    <td>{member.passing_year || '-'}</td>
                                                    <td>{member.discipline || '-'}</td>
                                                    <td>
                                                        <span className={`badge badge-${member.status === 1 ? 'success' : 'danger'}`}>
                                                            {member.status === 1 ? 'Active' : 'Inactive'}
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="7" className="text-center py-4">
                                                No members found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateGroupemail;